import { lazy, Suspense } from 'react';

import RequirePermission from '../components/AuthGuards/RequirePermission';

const Licensing = lazy(() => import('../pages/Licensing'));

export const LicensingRoutes = [
  {
    path: 'licensing',
    // rights.manage as a READ surface: the page shows the licence terms at the
    // point of use, and hasPermission counts 'view' - which every role in the
    // tenant holds - per the row note "Read by everyone in the tenant so the
    // terms are visible at the point of use".
    element: (
      <RequirePermission permission="rights.manage">
        <Suspense fallback={<></>}>
          <Licensing />
        </Suspense>
      </RequirePermission>
    ),
  },
];
